import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';
import { Button, Stack } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Reel from '../tools/Reel';
import React, { useState, useEffect } from "react";
import {
    Box,
    Container,
    Grid,
    Card,
    CardContent,
    Tabs,
    Tab,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Backdrop,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { motion } from "framer-motion";
import FilePreview from '../tools/FilePreview';
const live_events_service = require('../../helpers/live_events_service');

const MotionCard = motion(Card);

const primary = "#4B3FA0";
const primaryLight = "rgba(75,63,160,0.08)";
const sectionGap = 8; // consistent vertical spacing between sections (MUI spacing units)

const levels = {
    diamante: {
        name: "Diamante",
        price: "$11,800",
        color: "#E5E4E2",
        benefits: [
            "Logotipo en página del evento (link a su web)",
            "Conferencista destacado (30–40 min) – sujeto a aprobación del comité académico",
            "Producción y edición de video exclusivo del conferencista para redes EBG",
            "Reconocimiento de marca en medios impresos y digitales",
            "Acceso exclusivo a plataforma de Networking con participantes",
            "Presencia de marca dentro del salón de conferencias y áreas estratégicas",
            "Email marketing a bases de datos ABG y EBG",

            "Gafetes de staff: 3 staff + 1 conferencista (incluye alimentos)",
            "3 participaciones de cortesía",
            "Transmisión de spot publicitario en salón (30 seg – 1 min)",
            "Stand 3×2 m con Pantalla LED",
        ],
    },
    platino: {
        name: "Platino",
        price: "$7,800",
        color: "#E5E4E2",
        benefits: [
            "Logotipo en página del evento (link a su web)",
            "Representación en el Foro – sujeto a aprobación del comité académico",
            "Reconocimiento de marca en medios impresos y digitales",
            "Acceso exclusivo a plataforma de Networking con participantes",
            "Email marketing a bases de datos ABG y EBG",

            "Gafetes de staff: 2 staff (incluye alimentos)",
            "2 participaciones de cortesía",
            "Stand 3×2 m",
        ],
    },
    oro: {
        name: "Oro",
        price: "$5,800",
        color: "#E5E4E2",
        benefits: [
            "Logotipo en página del evento (link a su web)",
            "Reconocimiento de marca en medios impresos y digitales",
            "Acceso exclusivo a plataforma de Networking con participantes",
            "Email marketing a bases de datos ABG y EBG",

            "Gafetes de staff: 2 staff (incluye alimentos)",
            "1 participación de cortesía",
            "Stand 3×2 m",
        ],
    },
};

const benefitsComparison = [
    { benefit: "Logotipo en página del evento (link a su web)", diamante: true, platino: true, oro: true },
    { benefit: "Presencia como conferencista / representación en Foro", diamante: "Conferencia 30–40 min", platino: "Representación en Foro", oro: false },
    { benefit: "Video exclusivo del conferencista en redes EBG", diamante: true, platino: false, oro: false },
    { benefit: "Reconocimiento de marca en medios impresos y digitales", diamante: true, platino: true, oro: true },
    { benefit: "Acceso exclusivo a plataforma de Networking", diamante: true, platino: true, oro: true },
    { benefit: "Presencia de marca en salón de conferencias", diamante: true, platino: false, oro: false },
    { benefit: "Email marketing a bases ABG y EBG", diamante: true, platino: true, oro: true },
    { benefit: "Gafetes de staff (con alimentos)", diamante: "3 staff + 1 conferencista", platino: "2 staff", oro: "2 staff" },
    { benefit: "Participaciones de cortesía", diamante: "3", platino: "2", oro: "1" },
    { benefit: "Spot en salón de conferencias (30 seg – 1 min)", diamante: true, platino: false, oro: false },
    { benefit: "Stand en área de exposición", diamante: "3×2 m + Pantalla LED", platino: "3×2 m", oro: "3×2 m" },
];

const extras = [
    {
        title: "Cóctel de Bienvenida",
        price: "$20,000",
        desc: "Incluye boquitas, bebidas, músico solista y branding del patrocinador. Sin costo adicional. (1 empresa)",
    },
    {
        title: "Almuerzo Patrocinado",
        price: "$15,200",
        desc: "Presentación especial o reel de videos del patrocinador + músico solista contratado por los organizadores. (1 empresa por día)",
    },
    {
        title: "Coffee Breaks",
        price: "$13,000",
        desc: "Islas de servicio con la imagen del patrocinador. (1 empresa por día)",
    },
    {
        title: "Carpetas Oficiales",
        price: "$18,000",
        desc: "250 carpetas con logotipo impreso de la empresa patrocinadora + logotipo del congreso. (1 empresa)",
    },
    {
        title: "Maletines de Viaje",
        price: "$18,000",
        desc: "250 maletines con logotipo impreso de la empresa patrocinadora + logotipo del congreso. (1 empresa)",
    },
    {
        title: "Cintas de Gafetes",
        price: "$13,500",
        desc: "Imagen exclusiva como patrocinador del Congreso en el cinto. (1 empresa)",
    },
];

const generalBenefits = [
    "Posicionamiento de marca regional en Latinoamérica",
    "Acceso a +250 participantes latinoamericanos",
    "Networking estratégico con líderes de talento humano y sector financiero",
    "Exposición en medios digitales e impresos",
    "Participación en conferencias y actividades del congreso",
];

const renderCell = (value) => {
    if (value === true) return <CheckCircleIcon sx={{ color: primary }} />;
    if (value === false) return <CancelIcon sx={{ color: "#ccc" }} />;
    return (
        <Typography variant="body2" sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
            {value}
        </Typography>
    );
};

/* ─── Reusable Section Header ─── */
const SectionHeader = ({ children }) => (
    <Box mb={4}>
        <Typography variant="h5" fontWeight="bold" sx={{ color: primary }}>
            {children}
        </Typography>
        <Box
            sx={{
                mt: 1,
                width: 48,
                height: 4,
                borderRadius: 2,
                background: primary,
                opacity: 0.25,
            }}
        />
    </Box>
);

const Patrocinio = () => {
    const [tab, setTab] = useState("diamante");
    const [contador] = useState(0);
    const [loading, setLoading] = useState(true);
    const [url, setUrl] = useState("");

    useEffect(() => {
        live_events_service
            .getData("/evento/view-by-hash/" + process.env.REACT_APP_EVT)
            .then((response_evt) => {
                live_events_service
                    .getData("/patrocinador/view-by-evento/" + process.env.REACT_APP_EVT)
                    .then(() => {
                        live_events_service
                            .getData(`/conferencista/read/${process.env.REACT_APP_EVT}`)
                            .then(() => {
                                setUrl(response_evt.data.response_database.result[0].planos);
                                setLoading(false);
                            })
                            .catch(console.log);
                    })
                    .catch(console.log);
            })
            .catch(console.log);
    }, [contador]);

    return (
        <Stack spacing={0} alignItems="center" sx={{ background: "#f5f7f6" }} pt={3}>

            {/* ── Loading ── */}
            <Backdrop sx={{ color: "#fff", zIndex: (t) => t.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* ── Breadcrumb ── */}
            <Box sx={{ width: "100%", px: { xs: 2, md: 4 } }}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" sx={{ display: "flex", alignItems: "center" }} color="inherit" href="/">
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Inicio
                    </Link>
                    <Typography sx={{ color: "text.primary", display: "flex", alignItems: "center" }}>
                        <AttachMoneyIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Patrocinio
                    </Typography>
                </Breadcrumbs>
            </Box>

            {/* ── Reel ── */}
            <Box sx={{ width: "100%" }}>
                <Reel />
            </Box>

            {/* ══════════════════════ MAIN CONTENT ══════════════════════ */}
            <Box sx={{ width: "100%", py: { xs: 6, md: 10 } }}>
                <Container maxWidth="lg">

                    {/* ── Hero Header ── */}
                    <Box
                        sx={{
                            mb: sectionGap,
                            pb: sectionGap,
                            borderBottom: `1px solid rgba(75,63,160,0.12)`,
                        }}
                    >
                        <Typography
                            variant="h4"
                            fontWeight="bold"
                            sx={{ color: primary, letterSpacing: "-0.5px", mb: 2 }}
                        >
                            PATROCINIOS CLADE 2026
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary", mb: 1 }}>
                            III Congreso Latinoamericano de Desarrollo del Talento Humano —{" "}
                            <Box component="strong" sx={{ color: "text.primary" }}>
                                Hotel Barceló, Ciudad de Guatemala
                            </Box>
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: 680 }}>
                            Conecta con más de{" "}
                            <Box component="strong" sx={{ color: "text.primary" }}>
                                250 líderes latinoamericanos
                            </Box>{" "}
                            del sector financiero y de talento humano. Posiciona tu marca y genera oportunidades reales de negocio en el evento más importante de desarrollo del talento en Centroamérica.
                        </Typography>
                    </Box>

                    {/* ── Nivel Tabs ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <SectionHeader>NIVELES DE PATROCINIO</SectionHeader>

                        <Tabs
                            value={tab}
                            onChange={(_, val) => setTab(val)}
                            sx={{
                                mb: 4,
                                "& .MuiTabs-indicator": { backgroundColor: primary, height: 3, borderRadius: 2 },
                            }}
                            textColor="inherit"
                        >
                            {Object.keys(levels).map((key) => (
                                <Tab
                                    key={key}
                                    value={key}
                                    label={levels[key].name}
                                    sx={{
                                        fontWeight: "bold",
                                        color: tab === key ? primary : "text.secondary",
                                        textTransform: "none",
                                        fontSize: "1rem",
                                        mr: 1,
                                    }}
                                />
                            ))}
                        </Tabs>

                        <MotionCard
                            key={tab}
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                            elevation={0}
                            sx={{
                                borderRadius: 4,
                                border: `1.5px solid rgba(75,63,160,0.15)`,
                                overflow: "hidden",
                            }}
                        >
                            {/* Colored top bar */}
                            <Box sx={{ height: 6, background: levels[tab].color }} />

                            <Box sx={{ p: { xs: 3, md: 5 } }}>
                                <Typography variant="h5" fontWeight="bold" sx={{ color: primary, mb: 4 }}>
                                    Nivel {levels[tab].name}
                                </Typography>

                                <Grid container spacing={1}>
                                    {levels[tab].benefits.map((b, i) => (
                                        <Grid item xs={12} sm={6} key={i}>
                                            <ListItem disableGutters sx={{ py: 0.75, alignItems: "flex-start" }}>
                                                <ListItemIcon sx={{ minWidth: 32, mt: "2px" }}>
                                                    <CheckCircleIcon sx={{ color: primary, fontSize: 20 }} />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={b}
                                                    primaryTypographyProps={{ variant: "body2", color: "text.secondary" }}
                                                />
                                            </ListItem>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </MotionCard>
                    </Box>

                    {/* ── Tabla Comparativa ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <SectionHeader>COMPARATIVO DE BENEFICIOS</SectionHeader>

                        <TableContainer
                            component={Paper}
                            elevation={0}
                            sx={{
                                borderRadius: 4,
                                border: `1.5px solid rgba(75,63,160,0.12)`,
                                overflow: "hidden",
                            }}
                        >
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#1a1a2e" }}>
                                        <TableCell
                                            sx={{ color: "#fff", fontWeight: "bold", width: "40%", py: 2, fontSize: "0.85rem" }}
                                        >
                                            Beneficio
                                        </TableCell>
                                        {["Diamante", "Platino", "Oro"].map((lvl) => (
                                            <TableCell
                                                key={lvl}
                                                align="center"
                                                sx={{ color: "#E5E4E2", fontWeight: "bold", py: 2, fontSize: "0.85rem" }}
                                            >
                                                {lvl}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {benefitsComparison.map((row, i) => (
                                        <TableRow
                                            key={i}
                                            sx={{
                                                "&:nth-of-type(odd)": { backgroundColor: primaryLight },
                                                "&:hover": { backgroundColor: "rgba(75,63,160,0.12)" },
                                                transition: "background 0.2s",
                                            }}
                                        >
                                            <TableCell sx={{ fontSize: "0.82rem", py: 1.5, color: "text.secondary" }}>
                                                {row.benefit}
                                            </TableCell>
                                            <TableCell align="center" sx={{ py: 1.5 }}>{renderCell(row.diamante)}</TableCell>
                                            <TableCell align="center" sx={{ py: 1.5 }}>{renderCell(row.platino)}</TableCell>
                                            <TableCell align="center" sx={{ py: 1.5 }}>{renderCell(row.oro)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* ── File Preview ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <FilePreview url={url} />
                    </Box>

                    {/* ── Beneficios Generales ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <SectionHeader>BENEFICIOS GENERALES</SectionHeader>

                        <Grid container spacing={3}>
                            {generalBenefits.map((item, i) => (
                                <Grid item xs={12} sm={6} md={4} key={i}>
                                    <MotionCard
                                        whileHover={{ y: -4 }}
                                        transition={{ duration: 0.2 }}
                                        elevation={0}
                                        sx={{
                                            height: "100%",
                                            p: 3,
                                            borderRadius: 4,
                                            border: `1.5px solid rgba(75,63,160,0.12)`,
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: 2,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                minWidth: 36,
                                                height: 36,
                                                borderRadius: "50%",
                                                background: primaryLight,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mt: "2px",
                                            }}
                                        >
                                            <CheckCircleIcon sx={{ color: primary, fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                                            {item}
                                        </Typography>
                                    </MotionCard>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* ── Experiencias Premium ── */}
                    <Box sx={{ mb: sectionGap }}>
                        <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={2} mb={4}>
                            <SectionHeader>EXPERIENCIAS PREMIUM</SectionHeader>

                            {/* Arrow buttons */}
                            <Box display="flex" gap={1} alignItems="center" mt={0.5}>
                                <Box
                                    component="button"
                                    onClick={() => {
                                        const el = document.getElementById("extras-scroll");
                                        if (el) el.scrollBy({ left: -320, behavior: "smooth" });
                                    }}
                                    sx={{
                                        width: 40, height: 40,
                                        borderRadius: "50%",
                                        border: `1.5px solid rgba(75,63,160,0.25)`,
                                        background: "#fff",
                                        color: primary,
                                        cursor: "pointer",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: "1.3rem",
                                        lineHeight: 1,
                                        transition: "all 0.2s",
                                        "&:hover": { background: primary, color: "#fff", borderColor: primary },
                                    }}
                                >
                                    ‹
                                </Box>
                                <Box
                                    component="button"
                                    onClick={() => {
                                        const el = document.getElementById("extras-scroll");
                                        if (el) el.scrollBy({ left: 320, behavior: "smooth" });
                                    }}
                                    sx={{
                                        width: 40, height: 40,
                                        borderRadius: "50%",
                                        border: `1.5px solid rgba(75,63,160,0.25)`,
                                        background: "#fff",
                                        color: primary,
                                        cursor: "pointer",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: "1.3rem",
                                        lineHeight: 1,
                                        transition: "all 0.2s",
                                        "&:hover": { background: primary, color: "#fff", borderColor: primary },
                                    }}
                                >
                                    ›
                                </Box>
                            </Box>
                        </Box>

                        {/* Horizontal scrollable strip with drag-to-scroll */}
                        <Box
                            id="extras-scroll"
                            ref={(el) => {
                                if (!el || el._dragBound) return;
                                el._dragBound = true;
                                let isDown = false, startX = 0, scrollLeft = 0;
                                el.addEventListener("mousedown", (e) => {
                                    isDown = true;
                                    el.style.cursor = "grabbing";
                                    startX = e.pageX - el.offsetLeft;
                                    scrollLeft = el.scrollLeft;
                                });
                                const stop = () => { isDown = false; el.style.cursor = "grab"; };
                                el.addEventListener("mouseleave", stop);
                                el.addEventListener("mouseup", stop);
                                el.addEventListener("mousemove", (e) => {
                                    if (!isDown) return;
                                    e.preventDefault();
                                    const x = e.pageX - el.offsetLeft;
                                    el.scrollLeft = scrollLeft - (x - startX) * 1.5;
                                });
                            }}
                            sx={{
                                display: "flex",
                                gap: 3,
                                overflowX: "auto",
                                pb: 1,
                                cursor: "grab",
                                userSelect: "none",
                                scrollbarWidth: "none",
                                "&::-webkit-scrollbar": { display: "none" },
                                scrollSnapType: "x mandatory",
                            }}
                        >
                            {extras.map((item, i) => (
                                <MotionCard
                                    key={i}
                                    whileHover={{ y: -5 }}
                                    transition={{ duration: 0.2 }}
                                    elevation={0}
                                    sx={{
                                        minWidth: { xs: 260, sm: 300 },
                                        maxWidth: { xs: 260, sm: 300 },
                                        borderRadius: 4,
                                        border: `1.5px solid rgba(75,63,160,0.12)`,
                                        overflow: "hidden",
                                        flexShrink: 0,
                                        scrollSnapAlign: "start",
                                        display: "flex",
                                        flexDirection: "column",
                                        pointerEvents: "auto",
                                    }}
                                >
                                    <Box sx={{ height: 4, background: primary, opacity: 0.35 }} />
                                    <CardContent sx={{ p: 3, flexGrow: 1 }}>
                                        <Box
                                            sx={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 28, height: 28,
                                                borderRadius: "50%",
                                                background: primaryLight,
                                                mb: 2,
                                            }}
                                        >
                                            <Typography variant="caption" fontWeight="bold" sx={{ color: primary }}>
                                                {i + 1}
                                            </Typography>
                                        </Box>
                                        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: primary, mb: 1, lineHeight: 1.3 }}>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                                            {item.desc}
                                        </Typography>
                                    </CardContent>
                                </MotionCard>
                            ))}
                        </Box>
                    </Box>

                    {/* ── CTA ── */}
                    <Box
                        sx={{
                            textAlign: "center",
                            py: { xs: 6, md: 8 },
                            px: { xs: 3, md: 8 },
                            borderRadius: 4,
                            background: `linear-gradient(135deg, rgba(75,63,160,0.07) 0%, rgba(75,63,160,0.03) 100%)`,
                            border: `1.5px solid rgba(75,63,160,0.12)`,
                        }}
                    >
                        <Typography variant="h5" fontWeight="bold" sx={{ color: primary, mb: 1.5 }}>
                            ¿Listo para posicionar tu marca en CLADE 2026?
                        </Typography>
                        <Typography color="text.secondary" sx={{ mb: 4, maxWidth: 560, mx: "auto" }}>
                            Conviértete en patrocinador y conecta con los líderes del talento humano y el sector financiero de Latinoamérica.
                        </Typography>
                        <Button
                            href="mailto:ncuches@ebg.edu.gt?subject=Interés%20en%20Patrocinio%20CLADE%202026&body=Hola%20equipo%20EBG,%0A%0AEstoy%20interesado(a)%20en%20convertirme%20en%20patrocinador%20del%20CLADE%202026.%20Me%20gustaría%20recibir%20más%20información%20sobre%20los%20niveles%20de%20patrocinio,%20beneficios%20y%20disponibilidad.%0A%0AEmpresa:%20%0ANombre:%20%0ACargo:%20%0ATeléfono:%20%0APaís:%20%0A%0AQuedo%20atento(a)%20a%20su%20respuesta.%0A%0ASaludos."
                            variant="contained"
                            sx={{
                                px: 6,
                                py: 1.75,
                                background: primary,
                                color: "#fff",
                                borderRadius: 3,
                                fontWeight: "bold",
                                fontSize: "1rem",
                                textTransform: "none",
                                boxShadow: `0 8px 24px rgba(75,63,160,0.3)`,
                                transition: "transform 0.25s, box-shadow 0.25s",
                                "&:hover": {
                                    transform: "translateY(-2px)",
                                    boxShadow: `0 12px 32px rgba(75,63,160,0.4)`,
                                    background: primary,
                                },
                            }}
                        >
                            Quiero ser patrocinador
                        </Button>
                    </Box>

                </Container>
            </Box>
        </Stack>
    );
};

export default Patrocinio;